// extracted by mini-css-extract-plugin
module.exports = {"widget":"_39Hp8","icon":"_2dF9g"};
    if(module.hot) {
      // 1625485311024
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  